export const themeRadius = {
  none: '0',
  s: '4px',
  m: '8px',
  l: '16px',
  full: '100%'
};
